import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeasonalLeaseRateCalculatorComponent } from './components';
import { CommonComponentsModule } from '@app/common-components/common-components.module';
import { FormsModule } from '@angular/forms';
import { DirectMailService } from './services/direct-mail.service';
import { ListingConfigurationService } from './services/listing-configuration.service';
import { CheckInOutGridComponent } from './components/check-in-out-grid/check-in-out-grid.component';
import { CheckinConfigComponent } from './components/checkin-config/checkin-config.component';
import { CheckInEventsComponent } from './components/check-in-events/check-in-events.component';
import { CheckInEventGridComponent } from './components/check-in-event-grid/check-in-event-grid.component';
import { LinkToNewAdminListingComponent } from './components/link-to-new-admin-listing/link-to-new-admin-listing.component';
import { RouterModule } from '@app/shared2-components';
import { SeasonalLeaseGridViewComponent } from './components/seasonal-lease-grid-view/seasonal-lease-grid-view.component';
import { LandownerOnboardCodeEntryComponent } from './components/landowner-onboard-code-entry/landowner-onboard-code-entry.component';
import { OnboardWhyOAComponent } from './components/onboard-why-oa/onboard-why-oa.component';
import { OnboardFAQsComponent } from './components/onboard-faqs/onboard-faqs.component';
import { BenefitsBarComponent } from './components/benefits-bar/benefits-bar.component';


/**
 * Components and services that are shared between Landowner and Admin modules
 */
@NgModule({
    providers: [DirectMailService, ListingConfigurationService],
    imports: [CommonModule, CommonComponentsModule, FormsModule, RouterModule, SeasonalLeaseRateCalculatorComponent,
        CheckInOutGridComponent,
        CheckInOutGridComponent,
        CheckinConfigComponent,
        CheckInEventsComponent,
        CheckInEventGridComponent,
        LinkToNewAdminListingComponent,
        SeasonalLeaseGridViewComponent,
        LandownerOnboardCodeEntryComponent,
        OnboardWhyOAComponent,
        OnboardFAQsComponent,
        BenefitsBarComponent],
    exports: [
        SeasonalLeaseRateCalculatorComponent,
        OnboardWhyOAComponent,
        CheckInOutGridComponent,
        CheckinConfigComponent,
        CheckInEventsComponent,
        CheckInEventGridComponent,
        LinkToNewAdminListingComponent,
        SeasonalLeaseGridViewComponent,
        LandownerOnboardCodeEntryComponent,
        OnboardWhyOAComponent,
        OnboardFAQsComponent,
        BenefitsBarComponent
    ]
})
export class LandownerAdminSharedModule {}
